

















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import MailDialog from '@/modules/quotations/components/dialogs/MailPopup.vue';
import Card from '@/components/default/Card.vue';
import IncreaseByPercentagePopup from '@/modules/quotations/components/dialogs/IncreaseByPercentagePopup.vue';

import { DxTabs } from 'devextreme-vue';
import { DxForm, DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import QuotationDocument from '@/modules/quotations/components/QuotationDocument.vue';
import {
  QuotationsClient,
  QuotationDetailedDto,
  QuotationBlock,
  Settings,
  TunnelGroup,
  TunnelGroupsClient,
  UpdateQuotationDetailsCommand,
  RawMaterialGroupsClient,
  RawMaterialGroup,
  Article,
  ArticleCategory,
  ArticleCategoryClient,
  QuotationCalculatedValuesDto,
  QuotationLine,
} from '@/data/web-api-client';
import QuotationBlockCard from '@/modules/quotations/components/QuotationBlockCard.vue';
import QuotationDefaultCostsCard from '@/modules/quotations/components/QuotationDefaultCostsCard.vue';
import QuotationDetailsCard from '@/modules/quotations/components/QuotationDetailsCard.vue';
import QuotationArticleSummaryTable from '@/modules/quotations/components/QuotationArticleSummaryTable.vue';
import QuotationDiscountCard from '@/modules/quotations/components/QuotationDiscountCard.vue';
import { debounce } from 'lodash';
import ProjectIsOnHoldPopup from '@/components/projects/ProjectIsOnHoldPopup.vue';
import Helpers, { groupBy, sleep } from '@/helpers/Helper';
import ArticleSummaryTable, { EntityType, SummaryItem } from '@/components/articles/articleSummaryTable.vue';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    MailDialog,
    QuotationBlockCard,
    QuotationDetailsCard,
    Card,
    DxTabs,
    EventLogsTable,
    DxForm,
    DxSimpleItem,
    DxLabel,
    IncreaseByPercentagePopup,
    QuotationDocument,
    QuotationArticleSummaryTable,
    QuotationDefaultCostsCard,
    QuotationDiscountCard,
    ProjectIsOnHoldPopup,
    ArticleSummaryTable,
  },
})
export default class QuotationDetails extends Vue {
  entityType: EntityType = 'Quotation';
  declare currency: any;

  public quotation = new QuotationDetailedDto();
  public tunnelGroups: TunnelGroup[] = [];
  public rawMaterialGroups: RawMaterialGroup[] = [];

  leftPositionBottomBar: number = 0;
  navIndex: number = 0;
  loading: boolean = false;
  saving: boolean = false;
  dirty: boolean = false;
  disabled = false;
  forceUpdate = false;

  public articleCategories: ArticleCategory[] = [];
  private toggled: boolean = false;
  private quotationsClient: QuotationsClient = new QuotationsClient(undefined, this.$axios);
  private initialised: boolean = false;
  private persistedCleanUpPercentage?: number;
  private skipPersistedWasteDisposalRecalculation: boolean = false;

  articleMap: Map<string, any> = new Map();
  articleCategoryMap: Map<string, any> = new Map();

  tunnelGroupDiscountMap: Map<string, Map<string, any>> = new Map();
  rawMaterialGroupsMap: Map<string, Map<string, number>> = new Map();

  calculatedValuesMapPerBlock: Map<string, Map<string, any>> = new Map();
  calculatedTunnelGroupsMap: Map<string, any> = new Map();

  groupedMapArticlesInCategory: Map<string, Map<string | undefined, any[]>> = new Map();

  editedPrices: Map<string, Map<string, number>> = new Map();
  editedCosts: Map<string, Map<string, number>> = new Map();

  tunnelGroupsInfo: any[] = [];

  activeDiscountLines: number = 0;
  calculating: boolean = false;

  async mounted() {
    await this.loadData();

    if (document) {
      const bar = document.getElementById('savebar');

      if (bar) {
        const rect = bar.getBoundingClientRect();
        this.leftPositionBottomBar -= rect.left;
      }
    }
  }

  async loadData() {
    try {
      this.loading = true;

      this.tunnelGroups = await new TunnelGroupsClient(undefined, this.$axios).get();
      this.rawMaterialGroups = await new RawMaterialGroupsClient(undefined, this.$axios).getAll();
      this.quotation = await this.quotationsClient.getSingle(this.$route.params.id);
      this.articleCategories = await new ArticleCategoryClient(undefined, this.$axios).get();
      this.disabled = this.quotation.projectIsOnHold!;

      await this.calculateBlocks();
      this.syncPersistedDefaultCostPercentages();

      setTimeout(() => {
        this.initialised = true;

        if (this.$route.query.checkProjectOnHold === 'true' && this.quotation?.projectIsOnHold) {
          this.projectIsOnHoldPopup.show();
        }
      }, 500);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  async save() {
    try {
      this.initialised = false;
      this.saving = true;
      const updatedQuotation = this.updateLineValuesToSend(this.quotation);

      if (this.$refs.block) {
        if (Array.isArray(this.$refs.block)) {
          for (const block of this.$refs.block) {
            await (block as QuotationBlockCard).saveEditDataOfTreeList();
          }
        } else {
          await (this.$refs.block as QuotationBlockCard).saveEditDataOfTreeList();
        }
      }

      this.$nextTick(async () => {
        this.updateTunnelValues(updatedQuotation);
        const command = new UpdateQuotationDetailsCommand(updatedQuotation);
        console.log('QuotationDetails ~ this.$nextTick ~ command:', command);

        this.quotation = await this.quotationsClient.update(this.$route.params.id, command);
        this.syncPersistedDefaultCostPercentages();
        this.dirty = false;
        notificationService.showSuccessMessage('Opgeslagen');
      });
    } catch (err) {
      console.log('QuotationDetails ~ save ~ err:', err);
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
      setTimeout(() => {
        this.initialised = true;
      }, 500);
    }
  }

  updateTunnelValues(updatedQuotation: QuotationDetailedDto) {
    if (updatedQuotation.tunnelGroupsId != null) {
      var tunnelGroup = this.tunnelGroupsInfo.find(x => x.id === updatedQuotation.tunnelGroupsId);
      updatedQuotation.tunnelLabourCost = tunnelGroup?.labourCost ?? 0;
      updatedQuotation.tunnelMaterialCost = tunnelGroup?.materialCost ?? 0;
      updatedQuotation.tunnelTotalSubcontractorCost = tunnelGroup?.discount ?? 0;
      updatedQuotation.tunnelMargin = tunnelGroup?.margin ?? 0;
    }
    else {
      updatedQuotation.tunnelLabourCost = 0;
      updatedQuotation.tunnelMaterialCost = 0;
      updatedQuotation.tunnelTotalSubcontractorCost = 0;
      updatedQuotation.tunnelMargin = 0;
    }
  }

  updateLineValuesToSend(quotation: QuotationDetailedDto): QuotationDetailedDto {
    let copy = { ...quotation } as QuotationDetailedDto;

    if (copy.blocks == undefined) {
      return copy;
    }

    for (const block of copy.blocks) {
      const blockData = this.calculatedValuesMapPerBlock.get(block.title!);
      if (block.lines == undefined || block.lines.length == 0 || blockData == undefined) {
        continue;
      }

      for (let line of block.lines) {
        const lineData = blockData.get(line.lineId!);

        line.labourCost = lineData?.labourCost ?? 0;
        line.materialCost = lineData?.materialCost ?? 0;
      }
    }

    copy.calculatedValues = new QuotationCalculatedValuesDto({ margin: this.margin, total: this.totalWithDiscount });
    return copy;
  }

  async saveQuotationBlock(e: any) {
    this.dirty = true;

    this.calculateValues();
  }

  customerChanged(e: any) {
    this.quotation.customer = e;
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  removeBlock(index: number) {
    this.quotation.blocks!.splice(index, 1);
  }

  async removeQuote() {
    if (this.quotation && confirm(this.$t('messages.AreYouSure') as string)) {
      try {
        this.saving = true;
        await this.quotationsClient.remove(this.$route.params.id);
        this.$router.push('/quotations');
      } catch (err) {
        notificationService.showAxiosError(err);
      } finally {
        this.saving = false;
      }
    }
  }

  async openIncreaseByPercentagePopup() {
    (this.$refs.IncreaseByPercentagePopup as IncreaseByPercentagePopup).open();
  }

  toggle() {
    this.toggled = !this.toggled;

    const blocks = this.$refs.block as QuotationBlockCard[];

    blocks.forEach((block: QuotationBlockCard) => {
      (block.$refs.card as Card).setShowContent(this.toggled);
    });
  }

  createBlock() {
    if (!this.quotation) {
      throw Error('quotation is null');
    }
    const name = prompt('Geef de naam van de nieuwe blok op', '');
    if (name && name !== '') {
      this.quotation.blocks!.push(
        new QuotationBlock({
          title: name,
          lines: [],
          originalTotal: 0,
          totalDifference: 0,
          total: 0,
          margin: 0,
          showTitle: true,
          showTotals: true,
        })
      );

      this.calculateValues();
    }
  }

  //#region calculations

  async calculateBlocks() {
    this.initTunnelGroupDiscountMap();
    this.initRawMaterialgroupsMap();
    this.mapArticlesInQuotation();
    this.calculateValues();
  }

  rowUpdated(lineId: string) {
    this.calculateValues(lineId);
  }

  initTunnelGroupDiscountMap() {
    for (const tunnelGroup of this.tunnelGroups) {
      this.tunnelGroupDiscountMap.set(tunnelGroup.id!, new Map());
      this.rawMaterialGroupsMap.set(tunnelGroup.id!, new Map());
    }
  }

  initRawMaterialgroupsMap() {
    for (const rawMaterialGroup of this.rawMaterialGroups) {
      if (rawMaterialGroup.tunnelGroups == undefined || rawMaterialGroup.tunnelGroups.length == 0) {
        continue;
      }

      for (const tunnelGroup of rawMaterialGroup.tunnelGroups) {
        const tunnelGroupPart = this.rawMaterialGroupsMap.get(tunnelGroup.id!);

        if (tunnelGroupPart == undefined) {
          continue;
        }

        tunnelGroupPart.set(rawMaterialGroup?.id!, tunnelGroup.discountValue!);
      }
    }
  }

  mapArticlesInQuotation() {
    console.groupCollapsed('map articles');
    this.articleMap.clear();

    // selectMany
    const articleDataInQuotation = this.quotation.blocks?.flatMap((b) =>
      b.lines?.flatMap((l) => {
        return {
          articleId: l.articleId!,
          articleCategoryId: l.articleCategoryId ?? 'none',
          description: l.description?.trimEnd(),
          minimumDuration: l.minimumDuration!,
          targetDuration: l.targetDurationOfArticle,
          quantity: l.quantity!,
          materialCost: l.materialCost!,
          originalMaterialCost: l.originalMaterialCost!,
          labourCost: l.labourCost!,
          originalLabourCost: l.originalLabourCost,
          variant: l.variant,
          measuringUnit: l.measuringUnit,
        }!;
      })
    )!;

    // group by categoryId
    const groupedMapCategory: Map<string, any[]> = articleDataInQuotation.reduce(
      (entryMap, value) => entryMap.set(value!.articleCategoryId!, [...(entryMap.get(value!.articleCategoryId!) || []), value]),
      new Map()
    );

    // group by article for each category
    const groupedMapArticlesInCategory: Map<string, Map<string, any[]>> = new Map();
    for (const key of groupedMapCategory.keys()) {
      groupedMapArticlesInCategory.set(
        key,
        groupedMapCategory
          .get(key)!
          .reduce(
            (entryMap, value) => entryMap.set(`${value!.articleId!}:${value!.description}`, [...(entryMap.get(`${value!.articleId!}:${value!.description}`) || []), value]),
            new Map()
          )
      );
    }

    this.groupedMapArticlesInCategory = groupedMapArticlesInCategory;
    console.log('QuotationDetails ~ mapArticlesInQuotation ~ groupedMapArticlesInCategory:', groupedMapArticlesInCategory);

    for (const categoryKey of groupedMapArticlesInCategory.keys()) {
      const currentCategoryMap = groupedMapArticlesInCategory.get(categoryKey);

      const maxMinimumWorkMinutesPerArticle: number[] = [];
      const workEstimatedWorkMinutesPerArticle: number[] = [];

      for (const articleKey of currentCategoryMap?.keys()!) {
        const articles = currentCategoryMap?.get(articleKey!)!.map((article) => {
          return {
            articleId: article.articleId,
            minimumWorkMinutes: article.minimumDuration,
            description: article.description,
            targetDuration: article.targetDuration,
            labourCost: article.labourCost,
            workMinutes: parseFloat((article.targetDuration * article.quantity).toFixed(2)),
            quantity: article.quantity,
            materialCost: article.materialCost!,
            originalMaterialCost: article.originalMaterialCost!,
            originalLabourCost: article.originalLabourCost,
            variant: article.variant,
            measuringUnit: article.measuringUnit,
          };
        })!;

        console.groupCollapsed('QuotationDetails ~ articles ~ article:', `${articles[0].articleId}:${articles[0].description}`);
        const workMinutesOfArticle = articles.map((a) => a.workMinutes);
        console.log('QuotationDetails ~ mapArticlesInQuotation ~ workMinutesOfArticle:', workMinutesOfArticle);
        const quantitiesOfArticle = articles.map((a) => a.quantity);
        console.log('QuotationDetails ~ mapArticlesInQuotation ~ quantitiesOfArticle:', quantitiesOfArticle);
        const minimumWorkMinutes = Math.max(...articles.map((a) => a.minimumWorkMinutes));
        const totalWorkMinutesOfArticle = workMinutesOfArticle.reduce((a, b) => a! + b!);
        console.log('QuotationDetails ~ mapArticlesInQuotation ~ totalWorkMinutesOfArticle:', totalWorkMinutesOfArticle);
        const totalQuantityOfArticle: number = quantitiesOfArticle.reduce((a, b) => a! + b!);
        console.log('QuotationDetails ~ mapArticlesInQuotation ~ totalQuantityOfArticle:', totalQuantityOfArticle);

        console.groupEnd();
        this.articleMap.set(`${articles[0].articleId}:${articles[0].description}`, {
          minimumWorkMinutes: minimumWorkMinutes,
          totalWorkMinutesOfArticle: totalWorkMinutesOfArticle,
          totalQuantityOfArticle: totalQuantityOfArticle,
          targetDuration: articles[0].targetDuration,
          labourCost: articles[0].labourCost,
          materialCost: articles[0].materialCost,
          originalMaterialCost: articles[0].originalMaterialCost,
          articleCategoryId: categoryKey,
          originalLabourCost: articles[0].originalLabourCost,
          variant: articles[0].variant,
        });

        maxMinimumWorkMinutesPerArticle.push(minimumWorkMinutes);
        workEstimatedWorkMinutesPerArticle.push(totalWorkMinutesOfArticle);
      }

      const maxMinimumWorkMinutes = Math.max(...maxMinimumWorkMinutesPerArticle);
      const totalWorkMinutesInCategory = workEstimatedWorkMinutesPerArticle.reduce((a, b) => a! + b!);

      this.articleCategoryMap.set(categoryKey, { minimumWorkMinutes: maxMinimumWorkMinutes, totalWorkMinutesInCategory: totalWorkMinutesInCategory });
    }
    console.groupEnd();
  }

  calculateValues(lineId?: string) {
    this.calculating = true;
    this.mapArticlesInQuotation();
    this.calculateBlocksData(lineId);
    this.calculateTunnelGroupsData();

    this.forceUpdate = true;
    this.$nextTick(async () => {
      await this.displayTunnelGroupsDiscounts();
      this.forceUpdate = false;
      this.calculating = false;
    });
  }

  calculateLabourCost(
    labourCostOfArticle: number,
    targetDurationOfArticle: number,
    currentArticleMap: any,
    articleCategoryId: string | undefined,
    quantity: number
  ): { labourCost: number | undefined; extraWorkMinutes: number | undefined } {
    console.log('QuotationDetails ~ calculateLabourCost ~ labourCostOfArticle:', labourCostOfArticle);
    let labourCostPerMinute = labourCostOfArticle / targetDurationOfArticle; // labourcost / 60 => labourCost per minute
    console.log('QuotationDetails ~ calculateLabourCost ~ labourCostPerMinute:', labourCostPerMinute);

    if (isNaN(labourCostPerMinute)) {
      labourCostPerMinute = 0;
    }

    let extraWorkMinutes = 0;

    console.log('QuotationDetails ~ calculateLabourCost ~ targetDurationOfArticle:', targetDurationOfArticle);
    console.log('QuotationDetails ~ calculateLabourCost ~ articleCategoryId:', articleCategoryId);
    console.log('QuotationDetails ~ calculateLabourCost ~ quantity:', quantity);
    if (quantity == 0) {
      return {
        labourCost: labourCostOfArticle,
        extraWorkMinutes: extraWorkMinutes,
      };
    }

    // no article category
    if (articleCategoryId == undefined) {
      if (currentArticleMap.totalWorkMinutesOfArticle >= currentArticleMap.minimumWorkMinutes || currentArticleMap.totalQuantityOfArticle == 0) {
        return {
          labourCost: currentArticleMap.originalLabourCost!,
          extraWorkMinutes: extraWorkMinutes,
        };
      }

      extraWorkMinutes = this.calculateExtraWorkMinutes(currentArticleMap.minimumWorkMinutes, currentArticleMap.totalWorkMinutesOfArticle, 1);
    } else {
      // article category
      const itemsInCategory = this.groupedMapArticlesInCategory.get(articleCategoryId);
      const itemsInCategorySize = itemsInCategory?.size;
      const currentCategoryMap = this.articleCategoryMap.get(articleCategoryId);

      if (
        currentCategoryMap == undefined ||
        currentCategoryMap?.totalWorkMinutesInCategory == 0 ||
        currentCategoryMap?.totalWorkMinutesInCategory >= currentCategoryMap?.minimumWorkMinutes
      ) {
        const optimizedLabourValues = this.getOptimizedLabourValues(articleCategoryId, itemsInCategory, targetDurationOfArticle);
        const labourCost = optimizedLabourValues?.labourCost ?? currentArticleMap.originalLabourCost!;
        const minutesToSubtract = (optimizedLabourValues?.minutesToSubtract ?? 0) * -1;

        return {
          labourCost: labourCost,
          extraWorkMinutes: minutesToSubtract,
        };
      }

      extraWorkMinutes = this.calculateExtraWorkMinutes(currentCategoryMap.minimumWorkMinutes, currentCategoryMap.totalWorkMinutesInCategory, itemsInCategorySize!);
      console.log('QuotationDetails ~ calculateLabourCost ~ extraWorkMinutes:', extraWorkMinutes);
    }

    if (extraWorkMinutes <= 0) {
      extraWorkMinutes = 0;
    }

    const extraWorkMinutesPerUnit = extraWorkMinutes / currentArticleMap.totalQuantityOfArticle;
    console.log('QuotationDetails ~ calculateLabourCost ~ extraWorkMinutesPerUnit:', extraWorkMinutesPerUnit);

    const extraLabourCost = labourCostPerMinute * extraWorkMinutesPerUnit;
    console.log('QuotationDetails ~ calculateLabourCost ~ extraLabourCost:', extraLabourCost);

    let labourCost = targetDurationOfArticle * labourCostPerMinute + extraLabourCost;
    console.log('QuotationDetails ~ calculateLabourCost ~ labourCost:', labourCost);
    if (isNaN(labourCost)) {
      labourCost = 0;
    }

    return {
      labourCost: labourCost,
      extraWorkMinutes: extraWorkMinutesPerUnit,
    };
  }

  calculateExtraWorkMinutes(minimumWorkMinutes: number, totalWorkMinutesInCategory: number, items: number): number {
    if (isNaN(minimumWorkMinutes) || isNaN(totalWorkMinutesInCategory)) {
      return 0;
    }
    return parseFloat(((minimumWorkMinutes - totalWorkMinutesInCategory) / items!).toFixed(2));
  }

  calculatePrice(materialCost: number, labourCost: number, salesPriceMargin: number): number | undefined {
    if (isNaN(labourCost) || isNaN(materialCost)) {
      return 0;
    }

    const price = materialCost + labourCost + (materialCost + labourCost) * salesPriceMargin!;

    return parseFloat(price.toFixed(2));
  }

  calculateTotalValueOfLine(price: number, quantity: number): number {
    return price * quantity;
  }

  calculateBlocksData(lineId?: string) {
    let calculatedValuesMapPerBlock: Map<string, Map<string, any>> = new Map();

    calculatedValuesMapPerBlock = this.calculatedValuesMapPerBlock;

    if (!calculatedValuesMapPerBlock) {
      calculatedValuesMapPerBlock = new Map();
    }

    let matchingQuotationLineArticleCategoryId = this.quotation.blocks?.flatMap((b) => b.lines?.filter((l) => l.lineId == lineId))[0]?.articleCategoryId;

    for (const block of this.quotation.blocks!.filter((b) => b.title?.toLocaleLowerCase() != 'standaardkosten')) {
      console.groupCollapsed(block.title);
      let editedPricesOfBlock = this.editedPrices.get(block.title!)!;
      let editedCostsOfBlock = this.editedCosts.get(block.title!)!;

      // empty block skip
      if (!block.lines || block.lines.length <= 0) {
        console.groupEnd();
        return;
      }

      let calculatedValuesMap = new Map<string, any>();

      calculatedValuesMap = calculatedValuesMapPerBlock.get(block.title!)!;

      if (!calculatedValuesMap || block.lines.length != calculatedValuesMap.keys.length) {
        calculatedValuesMap = new Map<string, any>();
      }

      console.log('QuotationDetails ~ calculateBlocksData ~ calculatedValuesMap:', calculatedValuesMap);

      // foreach line in block do the calcs
      for (const quotationLine of block.lines!) {
        console.groupCollapsed(quotationLine.description);

        const previousCalculatedValuesMap = calculatedValuesMap.get(quotationLine.lineId!);
        if (lineId && matchingQuotationLineArticleCategoryId != quotationLine.articleCategoryId) {
          const previousCalcValuesForLine = calculatedValuesMap.get(quotationLine.lineId!);
          console.log('QuotationDetails ~ calculateBlocksData ~ previousCalcValuesForLine:', previousCalcValuesForLine);

          calculatedValuesMap.set(quotationLine.lineId!, previousCalcValuesForLine);

          console.groupEnd();
          continue;
        }

        const currentArticleMap = this.articleMap.get(`${quotationLine.articleId!}:${quotationLine.description}`);
        console.log('QuotationDetails ~ calculateBlocksData ~ currentArticleMap:', currentArticleMap);
        if (currentArticleMap == undefined) {
          console.groupEnd();
          continue;
        }

        const { labourCost, extraWorkMinutes } = this.calculateLabourCost(
          quotationLine.originalLabourCost!,
          quotationLine.targetDurationOfArticle!,
          currentArticleMap,
          quotationLine.articleCategoryId,
          quotationLine.quantity!
        );
        console.log('QuotationDetails ~ calculateBlocksData ~ labourCost:', labourCost);
        console.log('QuotationDetails ~ calculateBlocksData ~ extraWorkMinutes:', extraWorkMinutes);

        let materialCost = quotationLine.materialCost!;

        if (materialCost == 0 && quotationLine.originalMaterialCost != 0) {
          materialCost = quotationLine.originalMaterialCost!;
        }

        let price;
        if (lineId == null || lineId.trim() === '') {
          price = quotationLine.price;
        }

        // for new quotes do a full recalc
        if (this.quotation.lastModified?.getTime() == this.quotation.date?.getTime()) {
          price = undefined;
        }

        console.log('QuotationDetails ~ calculateBlocksData ~ price:', price);

        const editedPrice = editedPricesOfBlock?.get(quotationLine.lineId!);
        console.log('QuotationDetails ~ calculateBlocksData ~ editedPrice:', editedPrice);

        // 0 returns false so we need to specifically need to check for undefined
        if (editedPrice != undefined) {
          console.log('QuotationDetails ~ calculateBlocksData ~ previousCalculatedValuesMap:', previousCalculatedValuesMap);
          if (!previousCalculatedValuesMap || quotationLine?.quantity == previousCalculatedValuesMap?.quantity) {
            price = editedPrice!;
          } else {
            editedPricesOfBlock.delete(quotationLine.lineId!);
          }
          // when an editedPrice did get saved, it was recalced upon closing and opening the quotation where the editedPrice got lost
          // this way we should circumvent this loss of data
        } else if (editedPrice == undefined && quotationLine.price != quotationLine.originalPrice) {
          price = quotationLine.price;
        }

        if (price == undefined) {
          price = this.calculatePrice(materialCost, labourCost as number, quotationLine.salesPriceMargin!)!;

          console.log('QuotationDetails ~ calculateBlocksData ~ price:', price);

          if (price == 0 && quotationLine.price != 0) {
            price = previousCalculatedValuesMap?.price;
          }
        }

        let cost = quotationLine.cost;
        if (editedCostsOfBlock != undefined) {
          console.log('QuotationDetails ~ calculateBlocksData ~ editedCostsOfBlock.get(quotationLine.lineId!);:', editedCostsOfBlock.get(quotationLine.lineId!));
          cost = editedCostsOfBlock.get(quotationLine.lineId!);
        }

        if (Helpers.compareNumbers(price, quotationLine.price!, 0.01)) {
          price = quotationLine.price!;
        }

        if (Helpers.compareNumbers(cost!, quotationLine.cost!, 0.01)) {
          cost = quotationLine.cost!;
        }

        const calculatedValues = {
          labourCost: labourCost,
          materialCost: materialCost,
          price: price,
          cost: cost,
          quantity: quotationLine.quantity,
          total: this.calculateTotalValueOfLine(price, quotationLine.quantity!),
          extraWorkMinutes: extraWorkMinutes,
        };
        console.log('QuotationDetails ~ calculateBlocksData ~ calculatedValues:', calculatedValues);

        calculatedValuesMap.set(quotationLine.lineId!, calculatedValues);
        console.groupEnd();
      }

      calculatedValuesMapPerBlock.set(block.title!, calculatedValuesMap);
      console.log('QuotationDetails ~ calculateBlocksData ~ calculatedValuesMap:', calculatedValuesMap);
      console.groupEnd();
    }

    this.calculatedValuesMapPerBlock = calculatedValuesMapPerBlock;
    console.log('QuotationDetails ~ calculateBlocksData ~ this.calculatedValuesMapPerBlock:', this.calculatedValuesMapPerBlock);
    this.$forceUpdate();
  }

  //#region tunnelGroups

  calculateTunnelGroupsData() {
    if (!this.tunnelGroups || this.tunnelGroups.length <= 0 || this.tunnelGroupDiscountMap.size == 0) {
      return;
    }

    const excludedBlock = this.quotation.blocks?.find((b) => b.title == 'Standaardkosten');
    const excludedCodeNames = excludedBlock?.lines?.map((l) => l.articleId);

    for (const tunnelGroup of this.tunnelGroups) {
      console.groupCollapsed(tunnelGroup.name);
      this.tunnelGroupDiscountMap.set(tunnelGroup.id!, new Map());

      const tunnelGroupDiscount = this.tunnelGroupDiscountMap.get(tunnelGroup.id!)!;
      const rawMaterialsTunnelGroup = this.rawMaterialGroupsMap.get(tunnelGroup.id!)!;

      for (const articleIdDescription of this.articleMap.keys()) {
        console.log('QuotationDetails ~ calculateTunnelGroupsData ~ articleIdDescription:', articleIdDescription);
        const articleId = articleIdDescription.split(':')[0];
        const article = this.articleMap.get(articleIdDescription);
        console.log('QuotationDetails ~ calculateTunnelGroupsData ~ article:', article);
        const matchingArticle = this.articles.find((a) => a.id == articleId);

        // if (matchingArticle == undefined || excludedCodeNames?.some((cn) => cn == matchingArticle.id)) {
        //   continue;
        // }

        console.groupCollapsed(articleIdDescription);

        console.groupCollapsed('material');
        this.calculateMaterialCostForArticleInTunnelGroup(article, matchingArticle!, tunnelGroupDiscount, rawMaterialsTunnelGroup, tunnelGroup, articleIdDescription);
        console.groupEnd();

        console.groupCollapsed('labour');
        this.calculateLabourCostForArticleInTunnelGroup(article, matchingArticle!, tunnelGroupDiscount, tunnelGroup, articleIdDescription);
        console.groupEnd();

        console.groupEnd();
      }
      console.log('QuotationDetails ~ calculateTunnelGroupsData ~ this.tunnelGroupDiscountMap:', this.tunnelGroupDiscountMap);

      console.groupEnd();
    }
  }

  calculateMaterialCostForArticleInTunnelGroup(
    article: any,
    matchingArticle: Article,
    tunnelGroupDiscount: any,
    rawMaterialsTunnelGroup: any,
    tunnelGroup: TunnelGroup,
    articleIdDescription: string
  ) {
    const articleTunnelGroupDiscount = tunnelGroupDiscount?.get(articleIdDescription);

    if (articleTunnelGroupDiscount?.afterMaterialCostDiscount != undefined) {
      return;
    }

    const variantDataOfArticle = matchingArticle?.variants
      ?.find((v) => v.name == article.variant)
      ?.materials?.map((m) => {
        return {
          rawMaterialRef: m.rawMaterialRef,
          amount: m.amount,
        };
      });
    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ variantDataOfArticle:', variantDataOfArticle);

    const sumVariantDataOfArticle = variantDataOfArticle?.reduce((prev: any | any[], current) => {
      let array = [prev];

      if (Array.isArray(prev)) {
        array = [...prev];
      }

      let existingEl = array.findIndex((a) => a.rawMaterialRef == current.rawMaterialRef);
      if (array[existingEl]) {
        array[existingEl].amount! += current!.amount!;
      } else {
        array = [...array, current];
      }

      return array;
    }, []);
    console.log('QuotationDetails ~ sumVariantDataOfArticle ~ sumVariantDataOfArticle:', sumVariantDataOfArticle);

    const materialPricesOfTheArticles = this.rawMaterials
      .filter((rw) => variantDataOfArticle?.map((vda) => vda.rawMaterialRef!)?.includes(rw.id))
      .map((rw) => {
        return {
          id: rw.id,
          price: rw.defaultPrice?.purchasePriceDefaultMeasuringUnit,
          group: rw.materialGroup?.id,
        };
      });
    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ materialPricesOfTheArticles:', materialPricesOfTheArticles);
    let materialCost = 0;
    let originalMaterialCost = 0;

    if (matchingArticle && materialPricesOfTheArticles.length <= 0) {
      return;
    }

    const val = this.calculatedTunnelGroupsMap.get(tunnelGroup.id!);
    let rawMaterialGroups: string[] = [];

    if (val && val.rawMaterialGroups) {
      rawMaterialGroups = val.rawMaterialGroups;
    }

    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ materialPricesOfTheArticles:', materialPricesOfTheArticles);
    for (const mat of materialPricesOfTheArticles) {
      const material = sumVariantDataOfArticle.find((mia: any) => mia.rawMaterialRef == mat.id);
      const rawMaterialGroup = rawMaterialsTunnelGroup.get(mat.group)!;

      let price = mat.price * ((100 - tunnelGroup.materialMargin!) / 100);

      if (rawMaterialGroup != undefined) {
        rawMaterialGroups = [...rawMaterialGroups, mat.group].filter(onlyUnique);
        price = mat.price * ((100 - rawMaterialGroup) / 100);
      }

      materialCost += material?.amount! * price;
      originalMaterialCost += material?.amount! * mat.price;
    }

    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ materialCost:', materialCost);
    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ originalMaterialCost:', originalMaterialCost);
    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ rawMaterialGroups:', rawMaterialGroups);

    this.calculatedTunnelGroupsMap.set(tunnelGroup.id!, {
      rawMaterialGroups: rawMaterialGroups,
    });

    // manual lines
    if (!matchingArticle) {
      materialCost = article.materialCost;
      originalMaterialCost = article.materialCost;
    }

    if (materialCost == 0) {
      return;
    }

    const afterMaterialDiscountCost = materialCost * article.totalQuantityOfArticle;
    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ article.totalQuantityOfArticle:', article.totalQuantityOfArticle);
    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ afterMaterialDiscountCost:', afterMaterialDiscountCost);
    const totalOriginalMaterialCost = originalMaterialCost * article.totalQuantityOfArticle;
    console.log('QuotationDetails ~ calculateMaterialCostForArticleInTunnelGroup ~ totalOriginalMaterialCost:', totalOriginalMaterialCost);

    if (articleTunnelGroupDiscount == undefined) {
      tunnelGroupDiscount.set(articleIdDescription, {
        afterMaterialDiscountCost: afterMaterialDiscountCost,
        totalOriginalMaterialCost: totalOriginalMaterialCost,
      });

      return;
    }

    const data = { ...articleTunnelGroupDiscount, afterMaterialDiscountCost: afterMaterialDiscountCost, totalOriginalMaterialCost: totalOriginalMaterialCost };
    tunnelGroupDiscount.set(articleIdDescription, data);
  }

  calculateLabourCostForArticleInTunnelGroup(article: any, matchingArticle: Article, tunnelGroupDiscount: any, tunnelGroup: TunnelGroup, articleIdDescription: string) {
    const articleTunnelGroupDiscount = tunnelGroupDiscount?.get(articleIdDescription);
    if (articleTunnelGroupDiscount && articleTunnelGroupDiscount?.afterLabourCostDiscount != undefined) {
      return;
    }

    const categoryId = article.articleCategoryId == 'none' ? undefined : article.articleCategoryId;
    console.log('QuotationDetails ~ calculateLabourCostForArticleInTunnelGroup ~ categoryId:', categoryId);

    const { labourCost } = this.calculateLabourCost(article.originalLabourCost, article.targetDuration!, article, categoryId, article.totalQuantityOfArticle);
    console.log('QuotationDetails ~ calculateLabourCostForArticleInTunnelGroup ~ labourCost:', labourCost);

    let afterLabourDiscountCost = 0;
    let totalOriginalLabourCost = 0;

    if (labourCost != undefined) {
      afterLabourDiscountCost = ((labourCost * (100 - tunnelGroup.labourMargin!)) / 100) * article.totalQuantityOfArticle;
      console.log('QuotationDetails ~ calculateLabourCostForArticleInTunnelGroup ~ afterLabourDiscountCost:', afterLabourDiscountCost);
      totalOriginalLabourCost = labourCost * article.totalQuantityOfArticle;
      console.log('QuotationDetails ~ calculateLabourCostForArticleInTunnelGroup ~ totalOriginalLabourCost:', totalOriginalLabourCost);
    }

    if (articleTunnelGroupDiscount == undefined) {
      tunnelGroupDiscount.set(articleIdDescription, {
        afterLabourDiscountCost: afterLabourDiscountCost,
        totalOriginalLabourCost: totalOriginalLabourCost,
      });

      return;
    }

    const data = { ...articleTunnelGroupDiscount, afterLabourDiscountCost: afterLabourDiscountCost, totalOriginalLabourCost: totalOriginalLabourCost };
    tunnelGroupDiscount.set(articleIdDescription, data);
  }

  //#endregion tunnelGroups

  async updateEditedPrices(editedPricesOfBlock: Map<string, number>, blockTitle: string) {
    const existingEditedPricesForBlock = this.editedPrices.get(blockTitle);

    if (existingEditedPricesForBlock != undefined) {
      this.editedPrices.set(blockTitle, editedPricesOfBlock);

      return;
    }

    this.editedPrices.set(blockTitle, editedPricesOfBlock);
  }

  async updateEditedCosts(editedCostsOfBlock: Map<string, number>, blockTitle: string) {
    const existingEditedPricesForBlock = this.editedCosts.get(blockTitle);

    if (existingEditedPricesForBlock != undefined) {
      this.editedCosts.set(blockTitle, editedCostsOfBlock);
      return;
    }

    this.editedCosts.set(blockTitle, editedCostsOfBlock);
  }

  async displayTunnelGroupsDiscounts() {
    let retryCount = 0;
    while (this.totalWithDiscount == 0) {
      if (retryCount == 5) break;

      await sleep(100);
      retryCount++;
    }
    if (!this.tunnelGroupDiscountMap || this.tunnelGroupDiscountMap.size <= 0) {
      return this.tunnelGroupsInfo;
    }

    for (const [tunnelGroupKey, tunnelGroupCosts] of this.tunnelGroupDiscountMap) {
      let afterDiscountTotal = 0;
      let afterDiscountTotalLabourCost = 0;
      let afterDiscountTotalMaterialCost = 0;

      for (const articleKey of tunnelGroupCosts.keys()) {
        const article = tunnelGroupCosts.get(articleKey)!;

        afterDiscountTotal += article.afterLabourDiscountCost;
        afterDiscountTotalLabourCost += article.afterLabourDiscountCost;

        afterDiscountTotal += article.afterMaterialDiscountCost ?? 0;
        afterDiscountTotalMaterialCost += article.afterMaterialDiscountCost ?? 0;
      }

      const val = this.calculatedTunnelGroupsMap.get(tunnelGroupKey);

      this.calculatedTunnelGroupsMap.set(tunnelGroupKey, {
        ...val,
        afterDiscountTotal: afterDiscountTotal,
        afterDiscountTotalLabourCost: afterDiscountTotalLabourCost,
        afterDiscountTotalMaterialCost: afterDiscountTotalMaterialCost,
      });
    }

    let tunnelGroupsInfo: any[] = [];

    for (const [tunnelGroupKey, tunnelGroupData] of this.calculatedTunnelGroupsMap) {
      const matchingTunnelGroup = this.tunnelGroups.find((tg) => tg.id == tunnelGroupKey);

      const rawMaterialGroups = this.rawMaterialGroups
        .filter((rmg) => tunnelGroupData.rawMaterialGroups != undefined && tunnelGroupData.rawMaterialGroups.includes(rmg.id))
        .map((rmg) => rmg.name);

      const data = {
        name: matchingTunnelGroup?.name!,
        id: matchingTunnelGroup?.id,
        labourMargin: matchingTunnelGroup?.labourMargin!,
        labourCost: tunnelGroupData.afterDiscountTotalLabourCost!,
        materialMargin: matchingTunnelGroup?.materialMargin!,
        materialCost: tunnelGroupData.afterDiscountTotalMaterialCost!,
        discount: tunnelGroupData.afterDiscountTotal,
        margin: this.totalWithDiscount! - tunnelGroupData.afterDiscountTotal,
        rawMaterialGroups: rawMaterialGroups,
      };
      tunnelGroupsInfo.push(data);
    }

    console.log('QuotationDetails ~ displayTunnelGroupsDiscounts ~ tunnelGroupsInfo:', tunnelGroupsInfo);
    this.tunnelGroupsInfo = tunnelGroupsInfo;
  }

  private getOptimizedLabourValues(
    articleCategoryId: string,
    itemsInCategory: Map<string | undefined, any[]> | undefined,
    targetDurationOfArticle: number | undefined
  ): { labourCost: number; minutesToSubtract: number } | null {
    const category = this.articleCategories.find((ag) => ag.id === articleCategoryId);

    if (
      !category ||
      category.optimizationFrom === null ||
      category.optimizationFrom === undefined ||
      category.optimizationUntil === null ||
      category.optimizationUntil === undefined ||
      category.optimizationPercentage === null ||
      category.optimizationPercentage === undefined
    ) {
      return null;
    }

    const allOfferLines: any[] = [];
    const squareMetersRegExp = new RegExp('\u{B2}', 'u');

    for (const articleMap of itemsInCategory?.values()!) {
      for (const articleInMap of articleMap.values()) {
        if (squareMetersRegExp.test(articleInMap.measuringUnit.toLocaleLowerCase())) {
          allOfferLines.push(articleInMap);
        }
      }
    }

    if (allOfferLines.length === 0) {
      return null;
    }

    const totalQuantity = allOfferLines.reduce((acc, val) => (acc += val.quantity), 0);

    if (totalQuantity < category.optimizationFrom || totalQuantity > category.optimizationUntil) {
      return null;
    }

    const percentageToApply = (category.optimizationPercentage / (category.optimizationUntil - category.optimizationFrom)) * (totalQuantity - category.optimizationFrom);

    if (isNaN(percentageToApply)) {
      return null;
    }

    const roundedPercentage = Math.round((percentageToApply + Number.EPSILON) * 100) / 100;
    const minutesToSubtract = ((targetDurationOfArticle ?? 0) * roundedPercentage) / 100;
    const targetDuration = (targetDurationOfArticle ?? 0) - minutesToSubtract;
    const labourCost = targetDuration * (this.settings?.defaultHourRate! / 60);

    return {
      minutesToSubtract: minutesToSubtract,
      labourCost: labourCost,
    };
  }

  //#endregion

  get codeSummary(): SummaryItem[] {
    const summaryByCategories = this.settings.summaryInCategories;
    let result: SummaryItem[] = [];

    if (summaryByCategories) {
      if (!this.quotation.blocks) {
        return result;
      }

      const allLinesWithoutDefaultBlock = this.quotation.blocks.filter((b) => b.lines && b.title != 'Standaardkosten').flatMap((b) => b.lines);
      const allDefaultBlockLines = this.quotation.blocks.filter((b) => b.lines && b.title == 'Standaardkosten').flatMap((b) => b.lines);

      const groupedLinesByCategory: Map<string, QuotationLine[]> = allLinesWithoutDefaultBlock.reduce(
        (entryMap, value) => entryMap.set(value!.articleCategoryId!, [...(entryMap.get(value!.articleCategoryId!) || []), value]),
        new Map()
      );

      for (const [key, values] of groupedLinesByCategory) {
        var groupedLines: Map<string, QuotationLine[]> = groupBy(values, 'articleId');
        for (const [articleId, lines] of groupedLines) {
          if (lines.length == 0) continue;

          let line = lines[0];

          const quantitySum = lines.reduce((a: number, { quantity }) => a + quantity!, 0);
          const totalSum = lines.reduce((a: number, { total }) => a + total!, 0);

          const resultIndex = result.findIndex((o) => o.articleId === line.articleId);
          if (resultIndex === -1) {
            result.push({
              articleId: line.articleId!,
              description: line.description!,
              quantity: quantitySum,
              unitPrice: totalSum!,
              articleCategoryId: line.articleCategoryId!,
            });
          } else {
            result[resultIndex].quantity += quantitySum;
            result[resultIndex].unitPrice += totalSum!;
          }
        }
      }

      const nullCatLines = result.filter((r) => r.articleCategoryId == null);
      const catLines = result.filter((r) => r.articleCategoryId != null);
      result = [...catLines, ...nullCatLines];

      var groupedDefaultBlockLines: Map<string, QuotationLine[]> = groupBy(allDefaultBlockLines, 'articleId');
      for (const [articleId, lines] of groupedDefaultBlockLines) {
        if (lines.length == 0) continue;

        let line = lines[0];

        const quantitySum = lines.reduce((a: number, { quantity }) => a + quantity!, 0);
        const totalSum = lines.reduce((a: number, { total }) => a + total!, 0);

        const resultIndex = result.findIndex((o) => o.articleId === line.articleId);
        if (resultIndex === -1) {
          result.push({
            articleId: line.articleId!,
            description: line.description!,
            quantity: quantitySum,
            unitPrice: totalSum!,
            articleCategoryId: line.articleCategoryId!,
          });
        } else {
          result[resultIndex].quantity += quantitySum;
          result[resultIndex].unitPrice += totalSum!;
        }
      }

      result.forEach((resultItem) => {
        resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
      });

      return result;
    }

    // summary not grouped by categories
    if (!this.quotation.blocks) {
      return result;
    }

    for (const block of this.quotation.blocks.filter((b) => b.lines)) {
      for (const line of block.lines!) {
        if (line.articleId && line.articleId !== '' && line.quantity && line.total) {
          const resultIndex = result.findIndex((o) => o.articleId === line.articleId);
          if (resultIndex === -1) {
            result.push({
              articleId: line.articleId,
              description: line.description!,
              quantity: line.quantity,
              unitPrice: line.total,
              articleCategoryId: line.articleCategoryId!,
            });
          } else {
            result[resultIndex].quantity += line.quantity;
            result[resultIndex].unitPrice += line.total;
          }
        }
      }
    }

    result.forEach((resultItem) => {
      resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
    });

    return result;
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Basis info' },
      { icon: 'fas fa-info-circle', text: 'Samenvatting' },
      { icon: 'fas fa-file-pdf', text: 'Document' },
      { icon: 'fas fa-history', text: 'Geschiedenis' },
    ];
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.$route.params.id,
      type: EventLogsObjectType.Quotation,
    };
  }

  get total() {
    if (this.calculating) {
      return;
    }

    let res = 0;
    if (!this.quotation || !this.quotation.blocks || this.quotation.blocks.length <= 0) {
      return res;
    }

    this.quotation.blocks.forEach((block) => {
      if (block.lines && block.lines.length > 0) {
        const currentBlockData = this.calculatedValuesMapPerBlock.get(block.title!);

        block.lines.forEach((line: any) => {
          if (line.quantity && line.price) {
            const currentArticleData = currentBlockData?.get(line.lineId)!;
            if (currentArticleData) {
              res += currentArticleData.total;
            } else {
              res += line.quantity * line.price;
            }
          }
        });
      }
    });
    return res;
  }

  get totalWithoutDefaultCosts() {
    if (this.calculating) {
      return;
    }
    let res = 0;
    if (!this.quotation || !this.quotation.blocks || this.quotation.blocks.length <= 0) {
      return res;
    }

    this.quotation.blocks.forEach((block: any) => {
      if (block.lines && block.lines.length > 0 && block.title !== 'Standaardkosten') {
        const currentBlockData = this.calculatedValuesMapPerBlock.get(block.title!);

        block.lines.forEach((line: any) => {
          const currentArticleData = currentBlockData?.get(line.lineId)!;

          if (line.quantity && line.price) {
            if (currentArticleData) {
              res += currentArticleData.total;
            } else {
              res += line.quantity * line.price;
            }
          }
        });
      }
    });

    return res;
  }

  get totalWithDiscount() {
    if (isNaN(this.total!) || isNaN(this.totalDiscount!)) {
      return;
    }

    return this.total! - this.totalDiscount!;
  }

  get totalDiscount() {
    if (this.total == undefined || isNaN(this.total!)) {
      return;
    }
    let res = this.total;

    if (this.quotation.discountLines?.length! > 0) {
      const last = this.quotation.discountLines![this.quotation.discountLines!.length - 1];

      res -= last.totalWithDiscount!;
    }

    return res;
  }

  get settings(): Settings {
    return this.$store.getters['settings/data'];
  }

  private syncPersistedDefaultCostPercentages() {
    const defaultCostsBlock = this.quotation.blocks?.find((o) => o.title === 'Standaardkosten');
    if (!defaultCostsBlock || !defaultCostsBlock.lines || defaultCostsBlock.lines.length === 0) {
      this.persistedCleanUpPercentage = undefined;
      this.skipPersistedWasteDisposalRecalculation = false;
      return;
    }

    const baseTotal = this.totalWithoutDefaultCosts;
    this.persistedCleanUpPercentage = this.calculateStoredPercentage(
      defaultCostsBlock.lines.find((l) => l.articleId === this.settings.cleanUpPerUnitArticleId),
      baseTotal
    );
    this.skipPersistedWasteDisposalRecalculation = defaultCostsBlock.lines.some(
      (l) => l.articleId === this.settings.wasteDisposalArticleId || l.articleId === this.settings.wasteDisposalPerUnitArticleId
    );
  }

  private calculateStoredPercentage(line: QuotationLine | undefined, baseTotal: number | undefined) {
    if (!line || !line.price || !line.quantity || !baseTotal || baseTotal <= 0) {
      return undefined;
    }

    return ((line.quantity * line.price) / baseTotal) * 100;
  }

  get totalOriginal() {
    let res = 0;

    if (!this.quotation || !this.quotation.blocks || this.quotation.blocks.length <= 0) {
      return res;
    }

    this.quotation.blocks.forEach((block: any) => {
      if (block.lines && block.lines.length > 0) {
        block.lines?.forEach((line: QuotationLine) => {
          if (!line.articleId && line.price && line.quantity) {
            res += line.quantity * line.price;
            return;
          }
          if (line.quantity && line.originalPrice) {
            res += line.quantity * line.originalPrice;
          }
        });
      }
    });

    return res;
  }

  get totalCost() {
    let res = 0;
    if (!this.quotation || !this.quotation.blocks || this.quotation.blocks.length <= 0) {
      return res;
    }

    this.quotation.blocks.forEach((block: any) => {
      if (block.lines && block.lines.length > 0) {
        const currentBlockData = this.calculatedValuesMapPerBlock.get(block.title!);

        block.lines.forEach((line: any) => {
          let cost = line.cost ?? 0; // get cost

          const currentArticleData = currentBlockData?.get(line.lineId)!;

          if (currentArticleData) {
            cost = currentArticleData?.labourCost! + currentArticleData?.materialCost!;
          }

          // Calculate margin
          if (line.quantity && line.price) {
            res += line.quantity * cost;
          }
        });
      }
    });

    return res;
  }

  get margin() {
    if (this.total == undefined || isNaN(this.total!) || this.totalDiscount == undefined || isNaN(this.totalDiscount!) || this.totalCost == undefined || isNaN(this.totalCost)) {
      return;
    }

    return this.total - this.totalDiscount - this.totalCost;
  }

  get marginPercent() {
    if (this.margin == undefined || isNaN(this.margin) || this.totalWithDiscount == undefined || isNaN(this.totalWithDiscount)) {
      return;
    }

    return ((this.margin / this.totalWithDiscount) * 100).toFixed(2) + '%';
  }

  get totalLabourCost() {
    let res = 0;

    for (const block of this.quotation.blocks?.filter((b) => !!b.lines) ?? []) {
      for (const line of block.lines!) {
        res += line.labourCost ?? 0;
      }
    }

    return res;
  }

  get totalMaterialCost() {
    let res = 0;

    for (const block of this.quotation.blocks?.filter((b) => !!b.lines) ?? []) {
      for (const line of block.lines!) {
        res += line.materialCost ?? 0;
      }
    }

    return res;
  }

  get rawMaterials(): any[] {
    return this.$store.getters['rawmaterials/items'];
  }

  get articles(): Article[] {
    return this.$store.getters['articles/items'];
  }

  get projectIsOnHoldPopup() {
    return this.$refs.projectIsOnHoldPopup as ProjectIsOnHoldPopup;
  }

  @Watch('quotation', { deep: true })
  @Debounce(50)
  async function(newValue: QuotationDetailedDto) {
    if (this.initialised) {
      this.dirty = true;
    }

    // discountLines check
    if (newValue && newValue.discountLines) {
      const newSelectedDiscountLinesCount = newValue.discountLines.filter((dl) => dl.isSelected).length;

      if (this.activeDiscountLines !== newSelectedDiscountLinesCount) {
        await this.displayTunnelGroupsDiscounts();
      }
    }
  }

  @Watch('totalWithoutDefaultCosts')
  onTotalWithoutDefaultCostsChanged() {
    if (!this.initialised) {
      return;
    }

    // totalWithoutDefaultCosts
    const defaultCostsBlock = this.quotation.blocks!.find((o) => o.title === 'Standaardkosten');
    if (!defaultCostsBlock) {
      return;
    }

    const cleanupLine = defaultCostsBlock.lines!.find((l) => l.articleId === this.settings.cleanUpArticleId);
    const cleanupLinePerUnit = defaultCostsBlock.lines!.find((l) => l.articleId === this.settings.cleanUpPerUnitArticleId);
    if (cleanupLine) {
      cleanupLine.quantity = this.totalWithoutDefaultCosts;
    }
    if (cleanupLinePerUnit) {
      const cleanupPercentage = this.persistedCleanUpPercentage ?? this.settings.defaultCleanUpPercentage!;
      const percentageOfTotal = this.totalWithoutDefaultCosts! * 0.01 * cleanupPercentage;
      cleanupLinePerUnit.quantity = Math.ceil(percentageOfTotal / cleanupLinePerUnit.price!);
      const existingArticleInfo = this.articleMap.get(`${cleanupLinePerUnit.articleId}:${cleanupLinePerUnit.description}`);
      this.articleMap.set(`${cleanupLinePerUnit.articleId}:${cleanupLinePerUnit.description}`, {
        ...existingArticleInfo,
        totalQuantityOfArticle: cleanupLinePerUnit.quantity,
      });
    }

    const wasteDisposalLine = defaultCostsBlock.lines!.find((l) => l.articleId === this.settings.wasteDisposalArticleId);
    const wasteDisposalLinePerUnit = defaultCostsBlock.lines!.find((l) => l.articleId === this.settings.wasteDisposalPerUnitArticleId);
    if (wasteDisposalLine && !this.skipPersistedWasteDisposalRecalculation) {
      wasteDisposalLine.quantity = this.totalWithoutDefaultCosts;
    }
    if (wasteDisposalLinePerUnit && !this.skipPersistedWasteDisposalRecalculation) {
      const wasteDisposalPercentage = this.settings.defaultWasteDisposalPercentage!;
      const percentageOfTotal = this.totalWithoutDefaultCosts! * 0.01 * wasteDisposalPercentage;
      wasteDisposalLinePerUnit.quantity = Math.ceil(percentageOfTotal / wasteDisposalLinePerUnit.price!);
      const existingArticleInfo = this.articleMap.get(`${wasteDisposalLinePerUnit.articleId}:${wasteDisposalLinePerUnit.description}`);
      this.articleMap.set(`${wasteDisposalLinePerUnit.articleId}:${wasteDisposalLinePerUnit.description}`, {
        ...existingArticleInfo,
        totalQuantityOfArticle: wasteDisposalLinePerUnit.quantity,
      });
    }

    this.calculateTunnelGroupsData();
  }
}

function Debounce(delay: number) {
  return (target: any, prop: string) => {
    return {
      configurable: true,
      enumerable: false,
      value: debounce(target[prop], delay),
    };
  };
}

function onlyUnique(value: any, index: number, array: any[]) {
  return array.indexOf(value) === index;
}
